// extracted by mini-css-extract-plugin
export default {"header":"InstagramPost_header__mKHCq","photo":"InstagramPost_photo__H0iO7","footer":"InstagramPost_footer__DOq3J","rightIcon":"InstagramPost_rightIcon__WP55f"};